import { Component, OnInit, ViewChild } from '@angular/core'
import { Router } from '@angular/router'
import { SnackbarComponent } from 'src/app/components/snackbar/snackbar.component'
import { WbsService } from 'src/app/services/wbs.service'
import { FrontEndParams } from '@interserve/igx-angular'
import { environment } from 'src/environments/environment'
import { IsAccountService } from '@interserve/angular'

@Component({
    selector: 'app-select-area-for-areauser',
    templateUrl: './select-area-for-areauser.component.html',
    styleUrls: ['./select-area-for-areauser.component.scss'],
})
export class SelectAreaForAreauserComponent implements OnInit {
    @ViewChild('snackbar', { static: true }) private snackbar!: SnackbarComponent

    public frontendCd = 'selectAreaForAreauserV3'
    public title = 'エリアユーザー 管理／エリア選択'

    environmentKey = environment.environmentKey

    public loading = false
    public customerId = ''

    //WBSライブラリ用
    public frontEndParams!: FrontEndParams

    constructor(private wbsService: WbsService, private isAccountService: IsAccountService, private router: Router) {}

    ngOnInit() {
        this.customerId = this.isAccountService.account?.customerId ?? ''

        this.initialize()
    }
    async initialize() {
        this.loading = true
        try {
            //フロントエンド設定をWBSに渡す
            let param = { customerId: this.customerId }
            this.frontEndParams = this.wbsService.setFrontendParams(this.frontendCd, param)

            this.loading = false
        } catch (error) {
            this.snackbar.error('画面の初期化が失敗しました')
            this.loading = false
        }
    }
    actions = {
        gotoOwnerSetting: (event: any) => {
            this.router.navigate([`/create-area-owner/${event.id}`])
        },
        gotoUserSetting: (event: any) => {
            this.router.navigate([`/create-area-user/${event.id}`])
        },
    }
}
